export const GROUP_STATUS = 'status';
export const GROUP_PRODUCT = 'product';
export const GROUP_DATE_CREATED = 'date_created';
export const FILTER_STATUS_IS = 'status_is';
export const FILTER_STATUS_IS_NOT = 'status_is_not';
export const FILTER_STATUS_IN = 'status_in';
export const FILTER_STATUS_NOT_IN = 'status_not_in';
export const FILTER_HAS_PRODUCT = 'has_product';
export const FILTER_DOESNT_HAVE_PRODUCT = 'doesnt_have_product';
export const FILTER_HAS_ONE_OF_PRODUCT = 'has_one_of_product';
export const FILTER_DOESNT_HAVE_ONE_OF_PRODUCT = 'doesnt_have_one_of_product';
export const FILTER_DATE_CREATED_PRESET = 'date_created_preset';
export const FILTER_DATE_CREATED_IS = 'date_created_is';
export const FILTER_DATE_CREATED_IS_NOT = 'date_created_is_not';
export const FILTER_DATE_CREATED_AFTER = 'date_created_after';
export const FILTER_DATE_CREATED_BEFORE = 'date_created_before';
export const FILTER_DATE_CREATED_BETWEEN = 'date_created_between';

export const messageByFilter = {
  [FILTER_STATUS_IS]: (value) => `**status** is **${value}**`,
  [FILTER_STATUS_IS_NOT]: (value) => `**status** is not **${value}**`,
  [FILTER_STATUS_IN]: (value) => `**status** is one of **${value.join(', ')}**`,
  [FILTER_STATUS_NOT_IN]: (value) => `**status** is not one of **${value.join(', ')}**`,
  [FILTER_DATE_CREATED_PRESET]: (value) => `**date created** is **${value}**`,
  [FILTER_DATE_CREATED_IS]: (value) => `**date created** is **${value}**`,
  [FILTER_DATE_CREATED_IS_NOT]: (value) => `**date created** is not **${value}**`,
  [FILTER_DATE_CREATED_AFTER]: (value) => `**date created** is after **${value}**`,
  [FILTER_DATE_CREATED_BEFORE]: (value) => `**date created** is before **${value}**`,
  [FILTER_DATE_CREATED_BETWEEN]: (value) =>
    `**date created** is between **${value[0] || 'since'}** and **${value[1] || 'until'}**`,
};

export const filtersByGroup = {
  [GROUP_STATUS]: [FILTER_STATUS_IS, FILTER_STATUS_IS_NOT, FILTER_STATUS_IN, FILTER_STATUS_NOT_IN],
  [GROUP_PRODUCT]: [
    FILTER_HAS_PRODUCT,
    FILTER_DOESNT_HAVE_PRODUCT,
    FILTER_HAS_ONE_OF_PRODUCT,
    FILTER_DOESNT_HAVE_ONE_OF_PRODUCT,
  ],
  [GROUP_DATE_CREATED]: [
    FILTER_DATE_CREATED_PRESET,
    FILTER_DATE_CREATED_IS,
    FILTER_DATE_CREATED_IS_NOT,
    FILTER_DATE_CREATED_AFTER,
    FILTER_DATE_CREATED_BEFORE,
    FILTER_DATE_CREATED_BETWEEN,
  ],
};
